var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-avatar',{staticClass:"avatar",attrs:{"src":_vm.formataUrl(_vm.logo),"size":"190px"},nativeOn:{"click":function($event){return _vm.selectFile()}}}),_c('input',{ref:"fl",staticStyle:{"visibility":"hidden","width":"0","height":"0px","margin":"0"},attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }